import {useEffect} from "react";

export default function useClearStateTimeout(clearState, time = 60000) {
  useEffect(() => {
    const timeout = setTimeout(() => {
      clearState()
    }, time)
    return () => clearTimeout(timeout)
  }, [clearState, time]);
}